<template>
  <div>
    <el-input placeholder="请输入用户名或邮箱" v-model="keyword" class="input-with-select p-3" @keyup.enter.native="search">
      <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
    </el-input>
    <div v-for="item in userList" :key="item.id">
      <div class="mx-3 d-flex">
        <el-avatar :size="48" :src="item.userinfo_id.avatar" :fit="'cover'" @error="item.userinfo_id.avatar!==''">
          <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
        </el-avatar>
        <div class="ml-3 flex-fill" style="line-height:48px">
          {{ item.userinfo_id.username }}<span v-if="!item.userinfo_id.status" class="text-danger ml-3">已被封禁</span><br>{{ item.userinfo_id.email }}
        </div>
        <div>
          <template v-if="item.bloggerinfo_bloggerID">
            <el-button v-if="!item.bloggerinfo_bloggerID.is_group" class="ml-3" plain round size="mini"
                       @click="blogger_is_group(item,1)">开通群博
            </el-button>
            <el-button v-if="item.bloggerinfo_bloggerID.is_group" class="ml-3" type="warning" plain round size="mini"
                       @click="blogger_is_group(item,0)">关闭群博
            </el-button>

          </template>
          <span v-if="!item.bloggerinfo_bloggerID">未开通博客</span>
          <el-button v-if="item.userinfo_id.status" class="ml-3" type="danger" plain round size="mini"
                     @click="block_user(item,0)">封禁
          </el-button>
          <el-button v-if="!item.userinfo_id.status" class="ml-3" type="success" plain round size="mini"
                     @click="block_user(item,1)">解封
          </el-button>
<!--          <nav-link >-->
          <el-button class="ml-3" type="primary" round size="mini"
                     @click="login_status(item)">以此用户身份登录

          </el-button>

        </div>
      </div>
      <el-divider></el-divider>
    </div>
  </div>
</template>
<script>
import HaiwaiIcons from "@/components/Icons/Icons";
import { Avatar,Divider} from 'element-ui';

export default {
  name: "user-management",
  components: {
    [Avatar.name]: Avatar,
    [Divider.name]: Divider
  },
  data() {
    return {
      type:'recent',
      user: this.$store.state.user,
      keyword: '',
      userList: []
    }
  },
  mounted() {
  },
  methods: {
    search() {
      this.user.user_search(this.keyword).then(res => {
        if (res.status) {
          this.userList = res.data;
        }
      })
    },
    block_user(item, type) {
      this.user.user_delete(item.id, type).then(res => {
        if (res.status) {
          item.userinfo_id.status = item.userinfo_id.status === 1 ? 0 : 1
          this.$message.success(item.userinfo_id.status === 1 ? '成功解封！' : '已将此用户封禁！')
        }
      })
    },
    blogger_is_group(item, type) {
      this.user.blogger_is_group(item.id, type).then(res => {
        if (res.status) {
          this.$message.success(type ? "群博功能已开启！" : "群博功能已关闭！");
          this.search()
        }
      })
    },
    login_status(item){
      this.user.login_status(item.id).then(res => {
        if (res.status) {
          this.$router.go('/blog/user/' + item.id);
        }
      })
    },
  }
}
</script>
<style>

</style>